import { c as _c } from "react/compiler-runtime";
import { Box, Grid } from "@mui-wrapper";
import { DEFAULT_TEXT_FONT_SIZE, DEFAULT_TITLE_FONT_SIZE } from "@styles/common-styles";
import { PageSectionItem } from "@components/page-section/page-section-item";
import { FontWeights, Text } from "@flat-ui";
import { PageSectionInfoIcon } from "@components/page-section/page-section-info-icon";
import { useMediaQueryList } from "@hooks/use-media-query";
/** The space between compact sections, in theme spacing units */
const COMPACT_SECTION_SPACING = 4;

/**
 * Defines a page section that can be used in pages like account or settings,
 * includes a title, subtitle and a list of items.
 */
export function PageSection(t0) {
  const $ = _c(33);
  const {
    title,
    additionalInfo,
    tooltipInfo,
    subtitle,
    items,
    isLoading: t1,
    isTopSection: t2,
    isLastSection: t3,
    isCompact: t4,
    footerAction,
    shouldHideLeftColumn: t5,
    sectionDescription
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const isTopSection = t2 === undefined ? false : t2;
  const isLastSection = t3 === undefined ? false : t3;
  const isCompact = t4 === undefined ? false : t4;
  const shouldHideLeftColumn = t5 === undefined ? false : t5;
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const sectionSpacing = isCompact ? COMPACT_SECTION_SPACING : "75px";
  const t6 = isScreenSmOrSmaller && !isLastSection ? "20px" : "0px";
  let t7;
  if ($[0] !== t6) {
    t7 = {
      alignItems: "baseline",
      marginBottom: t6
    };
    $[0] = t6;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  let t8;
  if ($[2] !== additionalInfo || $[3] !== footerAction || $[4] !== isTopSection || $[5] !== sectionSpacing || $[6] !== shouldHideLeftColumn || $[7] !== subtitle || $[8] !== title || $[9] !== tooltipInfo) {
    t8 = !shouldHideLeftColumn && <Grid sx={{
      paddingRight: {
        xs: "0px",
        md: "60px"
      },
      paddingBottom: {
        xs: "30px",
        md: "0px"
      }
    }} size={{
      xs: 12,
      sm: 12,
      md: 12,
      lg: 4
    }}><Box sx={{
        marginTop: {
          md: isTopSection ? "24px" : sectionSpacing
        }
      }}><Box sx={{
          fontSize: DEFAULT_TITLE_FONT_SIZE,
          letterSpacing: "-0.16px",
          fontWeight: FontWeights.SemiBold,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}><Box>{title}</Box>{tooltipInfo && <PageSectionInfoIcon text={tooltipInfo} />}</Box>{additionalInfo && <Text variant="labelS" component="div" sx={{
          color: "text.secondary",
          textTransform: "uppercase"
        }}>{additionalInfo}</Text>}<Box sx={{
          fontSize: DEFAULT_TEXT_FONT_SIZE,
          marginTop: "10px"
        }}>{subtitle}</Box></Box>{footerAction && <Box sx={{
        pt: "1rem"
      }}>{footerAction}</Box>}</Grid>;
    $[2] = additionalInfo;
    $[3] = footerAction;
    $[4] = isTopSection;
    $[5] = sectionSpacing;
    $[6] = shouldHideLeftColumn;
    $[7] = subtitle;
    $[8] = title;
    $[9] = tooltipInfo;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = isTopSection ? "0px" : sectionSpacing;
  let t10;
  if ($[11] !== t9) {
    t10 = {
      marginTop: {
        md: t9
      }
    };
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== shouldHideLeftColumn) {
    t11 = shouldHideLeftColumn ? 12 : {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 8
    };
    $[13] = shouldHideLeftColumn;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== isLoading || $[16] !== isScreenSmOrSmaller || $[17] !== isTopSection || $[18] !== items) {
    let t13;
    if ($[20] !== isLoading || $[21] !== isScreenSmOrSmaller || $[22] !== isTopSection) {
      t13 = (item_0, index) => <PageSectionItem item={item_0} key={`page-subsection-${index}`} isLoading={isLoading} shouldShowTopBorder={index === 0 && !isTopSection && !isScreenSmOrSmaller} />;
      $[20] = isLoading;
      $[21] = isScreenSmOrSmaller;
      $[22] = isTopSection;
      $[23] = t13;
    } else {
      t13 = $[23];
    }
    t12 = items.filter(_temp).map(t13);
    $[15] = isLoading;
    $[16] = isScreenSmOrSmaller;
    $[17] = isTopSection;
    $[18] = items;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t12) {
    t13 = <Grid sx={t10} size={t11}>{t12}</Grid>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== sectionDescription || $[29] !== t13 || $[30] !== t7 || $[31] !== t8) {
    t14 = <Grid container={true} sx={t7}>{sectionDescription}{t8}{t13}</Grid>;
    $[28] = sectionDescription;
    $[29] = t13;
    $[30] = t7;
    $[31] = t8;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
}
function _temp(item) {
  return !item.isHidden;
}